import type { GoToShellController } from '../../packages/shell-controller/shell-controller'
import type { ShellHook } from './models'

export const initializeShellController: ShellHook = async () => {
  const controller = document.querySelector('goto-shell-controller') as GoToShellController
  controller?.initializeController()
}
